/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import usePageMeta from "utils/usePageMeta";
import MKBox from "components/MKBox";

// Layout
import SubPageLayout from "reusables/layouts/SubPageLayout";

// Sections
import Block_Section1 from "./sections/Block_Section1";
import Block_Section2 from "./sections/Block_Section2";

function BlockManagement() {
  usePageMeta({
    title: "Block Management Ireland | Spechs",
    description:
      "Professional block and apartment management services across Ireland. Compliance, maintenance, and tenant coordination.",
    canonical: "https://www.spechs.ie/property/block/",
  });
  return (
    <SubPageLayout title="Block Management">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Block_Section1 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Block_Section2 />
      </MKBox>
    </SubPageLayout>
  );
}

export default BlockManagement;
